import { defineStore } from "pinia"
import Keycloak, { type KeycloakConfig } from "keycloak-js"

const KEYCLOAK_JSON: KeycloakConfig = {
    realm: "org-plus",
    url: "https://login.iprpraha.cz/auth/",
    clientId: "d-app-eomp",
}

type LoginStore = {
    logged: boolean
    failedLogin: boolean
    keycloak: Keycloak | undefined
    roles: string[]
}

export const useLoginStore = defineStore("loginStore", {
    state: (): LoginStore => {
        return {
            logged: false,
            failedLogin: false,
            keycloak: undefined,
            roles: [],
        }
    },
    getters: {
        hasAccess(state) {
            return state.roles.length > 0
        },
    },
    actions: {
        async login() {
            try {
                this.keycloak = new Keycloak(KEYCLOAK_JSON)
                try {
                    const authenticated = await this.keycloak.init({
                        onLoad: "login-required",
                        locale: "cs",
                    })
                    this.resolveSuccessLogin(authenticated)
                } catch (err) {
                    this.resolveFailedLogin(err)
                }
            } catch (error) {
                this.resolveFailedLogin(error)
            }
        },
        async logout() {
            await this.keycloak?.logout()
        },
        resolveSuccessLogin(authenticated: boolean) {
            if (authenticated && this.keycloak) {
                this.logged = true
                const resourceAccess =
                    this.keycloak.resourceAccess?.[KEYCLOAK_JSON.clientId]
                if (!resourceAccess) {
                    this.roles = []
                } else {
                    this.roles = resourceAccess.roles
                }
                this.keycloak.onTokenExpired = () => {
                    this.keycloak?.updateToken(300)
                }
            } else {
                this.resolveFailedLogin()
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        resolveFailedLogin(err?: any) {
            console.log(err)
            this.failedLogin = true
        },
    },
})
